/* Publish by EComposer at 2026-09-30 10:20:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j1gyaezarjc"]=  window.__ectimmers["ecom-j1gyaezarjc"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-j1gyaezarjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j1gyaezarjc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r15i9qty5x9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r15i9qty5x9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7kb1fc63407').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7kb1fc63407', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sd6n3lvuhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sd6n3lvuhg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qc7bq3hovyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qc7bq3hovyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-onxslhmbl8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onxslhmbl8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j33bfte73pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j33bfte73pn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esmp8d2s1bh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esmp8d2s1bh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fddvcdtq1un').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fddvcdtq1un', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eab93qcpuq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eab93qcpuq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5t2lx61vcpt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5t2lx61vcpt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nxj8fmn7dwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nxj8fmn7dwm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsep7mqzd4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsep7mqzd4u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4cr7x4diub6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4cr7x4diub6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvoowt88br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvoowt88br', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pebzjtic6j9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pebzjtic6j9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22bq8s2nqlz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22bq8s2nqlz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32u8t2j1i6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32u8t2j1i6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dwcu2yh084').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dwcu2yh084', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1pashi1wul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1pashi1wul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7omqligvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7omqligvr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fiq6fec6ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fiq6fec6ot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzw9ik8ueja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzw9ik8ueja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkx7t36wp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkx7t36wp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aro5lmjvo4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aro5lmjvo4r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-15yydlfjct6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-15yydlfjct6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6rktpmva6o5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6rktpmva6o5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snvjyx5hq5e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snvjyx5hq5e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98n89w2z58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98n89w2z58', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm5lb861sia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm5lb861sia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edrmnr5xsck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edrmnr5xsck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32e9snsdwu3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32e9snsdwu3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr7jlkfxbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr7jlkfxbp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cxvzg5w6reb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxvzg5w6reb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tryytnchwx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tryytnchwx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f7ggk534hug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f7ggk534hug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l3c7b5tki6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l3c7b5tki6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbkvodywwmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbkvodywwmh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ui3n56t51l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ui3n56t51l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66ollmuqq85').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66ollmuqq85', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7krswso87yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7krswso87yn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6l74xv0wk5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6l74xv0wk5h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lr8gs93z1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lr8gs93z1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgl7uc8gckg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgl7uc8gckg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62efr3do7xy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62efr3do7xy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wk6tsb6ak7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wk6tsb6ak7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ch5saxqgh9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ch5saxqgh9w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ao9t20w6kwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ao9t20w6kwl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rpcn3sh32j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rpcn3sh32j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqkxeat8ntd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqkxeat8ntd', settings: {},isLive: true});
                        });
                    

                })();
            